<template lang="pug">
multiselect(
    :options="taxes"
    :multiple="multiple"
    :value="value"
    @select="onSelect"
    track-by="id"
    label="tax_disc"
    :placeholder="placeholder"
    :loading="onLoading('fetch-tax')"
)
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    props: {
        value: {
            type: Object,
            default: () => null,
        },

        multiple: {
            type: Boolean,
            default: false,
        },

        excludeIds: {
            type: Array,
            default: () => [],
        },

        placeholder: {
            type: String,
            default: 'Select Tax',
        },
    },

    computed: {
        ...mapGetters('tax', ['taxList']),

        taxes() {
            if (this.excludeIds.length) {
                return this.taxList.filter(
                    tax => !this.excludeIds.includes(tax.id),
                );
            }

            return this.taxList;
        },
    },

    mounted() {
        if (!this.taxList.length) {
            this.getTaxList();
        }
    },

    methods: {
        ...mapActions('tax', ['getTaxList']),

        onSelect(product) {
            this.$emit('input', product);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/selector/tax-selector.vue